import { useContext } from 'react';

import { EditorLocaleContext, type EditorLocaleValue } from './EditorLocaleContext';

export function useEditorLocale(): EditorLocaleValue {
  const context = useContext(EditorLocaleContext);

  if (context === null) {
    throw new Error('useEditorLocale must be used inside <EditorLocaleProvider>.');
  }

  return context;
}
